import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  title: () => __(translations.updateStockEnteryModal.title, 'Update stock entry'),
  name: () => __(translations.updateStockEnteryModal.name, 'Reference'),
  placeholder: () => __(translations.updateStockEnteryModal.placeholder, 'Enter reference'),
  location: () => __(translations.updateStockEnteryModal.location, 'Location'),
};
